import React, { useState, useEffect } from 'react'
import logo from '../../assets/logo.png';
import { Box } from '@radix-ui/themes';
import lukaLogo from '../../assets/Luka-Healthcare.png';
import { useLocation, NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { permissions, ROLE_TO_PERMISSION_KEY } from "../../config/permissions";
import { RiMenu2Fill } from 'react-icons/ri';

const SideBarMenu = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const { roleId } = useAuth();
    const location = useLocation();
    const permissionKey = ROLE_TO_PERMISSION_KEY[roleId];

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            const smallScreen = window.innerWidth < 768;
            setIsSmallScreen(smallScreen);
            
            // On small screens, sidebar defaults to collapsed (icon-only) — never hidden
            if (smallScreen) {
                setIsCollapsed(true);
            }
            // Note: do NOT touch isOpen — sidebar is always visible
        };

        // Set initial state based on screen size
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSidebar = () => {
        // On both small and large screens, toggle between collapsed and expanded
        setIsCollapsed(!isCollapsed);
    };

    return (
        <>
            {/* Sidebar Container - always visible, collapses to icons on small screens */}
            <div 
                className={`
                    ${isCollapsed ? 'w-[70px]' : 'w-[230px]'}
                    relative flex flex-col bg-gray-50 h-screen border-r-2 
                    transition-all duration-300 ease-in-out z-20 flex-shrink-0
                `}
            >
                <div 
                    style={{ "boxShadow": "0px 4px 28px rgba(0, 0, 0, 0.14)" }} 
                    className="flex items-center justify-center bg-[#F2F2F2] pt-[10px] h-[80px] cursor-pointer"
                    onClick={toggleSidebar}
                >
                    {isCollapsed ? (
                        <RiMenu2Fill size={24} className="text-gray-700" />
                    ) : (
                        <img src={logo} alt="Logo" />
                    )}
                </div>
                <div className="flex flex-col flex-1 h-screen overflow-y-auto">
                    <nav className="flex-1 bg-[#00b893]">
                        {permissions?.[permissionKey]?.map(({ label, path, logo, img }) => (
                            <NavLink
                                key={path}
                                to={`/${path}`}
                                className={({ isActive }) =>
                                    `flex flex-col items-center w-full h-auto px-[16px] py-[24px] text-white ${isActive ? 'bg-gray-950/10' : ''} hover:bg-gray-950/10 hover:text-gray-50`
                                }
                            >
                                {logo ? (
                                    <div className={`transition-all duration-300 flex items-center justify-center`}>
                                        {React.cloneElement(logo, {
                                            size: isCollapsed ? 35 : 56,
                                            style: { fontSize: isCollapsed ? '35px' : '56px', transition: 'all 300ms' }
                                        })}
                                    </div>
                                ) : (
                                    <img className='p-2 rounded-md transition-all duration-300' width={isCollapsed ? 40 : 66} src={img} alt="" />
                                )}
                                <div className={`overflow-hidden transition-all duration-300 ease-in-out flex justify-center ${isCollapsed ? 'max-h-0 opacity-0 mt-0' : 'max-h-[40px] opacity-100 mt-2'}`}>
                                    <span className="text-gray-50 font-normal text-xl whitespace-nowrap">{label}</span>
                                </div>
                            </NavLink>
                        ))}
                    </nav>
                </div>
                {!isCollapsed && (
                    <Box className='py-3 px-2.5 min-h-20'>
                        <img src={lukaLogo} alt="Luka Logo" />
                    </Box>
                )}
            </div>
        </>
    )
}

export default SideBarMenu;
